import { Outlet } from 'react-router-dom'
import { EasyImg } from 'src/components'

const Header = () => {
  return (
    <div className='header login'>
      <div className='header__left'>
        <EasyImg src={require('enasops/assets/layout/logo.png')} />
        <span>eNAS管理后台</span>
      </div>
      <div className='header__right'></div>
    </div>
  )
}

const Login = () => {
  return (
    <div className='main'>
      <div className='main__header'><Header /></div>
      <div className='main__body'>
        <Outlet />
      </div>
    </div>
  )
}

export default Login